// Core
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  padding-bottom: 32px;
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
  margin: 24px 0;
`;
